// import React from 'react'
// import { useStaticQuery, graphql } from 'gatsby'

// const BlogCommentList = (props) => {
// 	const { databaseId } = props;
// 	// const { databaseId } = props;
// 	// console.log(props);

// 	const getData = graphql`{
// 		allWpComment(sort: {date: ASC},){
// 		 edges {
// 			 node {
// 			   id
// 			   status
// 			   content
// 			   author {
// 				 node {
// 				   avatar {
// 					 url
// 				   }
// 				   name
// 				   url
// 				 }
// 			   }
// 			   post
// 			   date
// 			 }
// 		   }
// 		 }
// 	 } `

// 	const data = useStaticQuery(getData);
// 	console.log(data.allWpComment);


// 	const comments = data.allWpComment.edges.filter(
// 		comment => (comment.node.post && comment.node.post === databaseId) && (comment.node.status === 'approved' || comment.node.status === 'APPROVE')
// 	);


// 	console.log(comments);

// 	const getComments = () => comments.map((obj, index) => {
// 		const comment = obj.node;
// 		// console.log(comment);
// 		return (
// 			<article key={index} className="comment-item">
// 				<div className="comment-head">
// 					<img className="avatar" src={comment.author.node.avatar && comment.author.node.avatar.url} alt={comment.author.node.name} />
// 					<div className="comment-info">
// 						<h5 className="comment-author">{comment.author.node.name}</h5>
// 						<span className="comment-date">{comment.date}</span>
// 					</div>
// 				</div>
// 				<div className="comment-description" dangerouslySetInnerHTML={{ __html: comment.content }} />
// 			</article>
// 		)
// 	});

// 	if (comments.length > 0) {
// 		return (
// 			<section className="bloque-comentarios comentarios-list">
// 				<h3 className="title">Comentarios ({comments.length})</h3>
// 				{getComments()}
// 			</section>
// 		)
// 	}
// 	else
// 		return ''
// }

// export default BlogCommentList;


import React, { useEffect, useState } from 'react';

const BlogCommentList = ({ databaseId }) => {
	const [comments, setComments] = useState([]);

	useEffect(() => {
		fetch(`https://blog.brokalia.com/wp-json/wp/v2/comments?post=${databaseId}&per_page=100`)
			.then(response => response.json())
			.then(data => {
				setComments(data.filter(comment => comment.status === 'approved'));
			});
	}, [databaseId]);

	function formatDate(dateString) {
		// Crear un nuevo objeto Date a partir de la cadena de fecha proporcionada
		const date = new Date(dateString);

		// Extraer los componentes de la fecha
		const day = String(date.getDate()).padStart(2, '0'); // Día con dos dígitos
		const month = String(date.getMonth() + 1).padStart(2, '0'); // Mes con dos dígitos
		const year = date.getFullYear(); // Año con cuatro dígitos
		const hours = String(date.getHours()).padStart(2, '0'); // Hora con dos dígitos
		const minutes = String(date.getMinutes()).padStart(2, '0'); // Minutos con dos dígitos

		// Formatear la fecha como "DD/MM/YYYY a las HH:MM"
		return `${day}/${month}/${year} a las ${hours}:${minutes}`;
	}


	const getComments = () =>
		comments.map((comment, index) => (
			<article key={index} className="comment-item">
				<div className="comment-head">
					<img
						className="avatar"
						src={comment.author_avatar_urls["48"]}
						alt={comment.author_name}
					/>
					<div className="comment-info">
						<h5 className="comment-author">{comment.author_name}</h5>
						<span className="comment-date">{formatDate(comment.date)}</span>
					</div>
				</div>
				<div
					className="comment-description"
					dangerouslySetInnerHTML={{ __html: comment.content.rendered }}
				/>
			</article>
		));

	if (comments.length > 0) {
		return (
			<section className="bloque-comentarios comentarios-list">
				<h3 className="title">Comentarios ({comments.length})</h3>
				{getComments()}
			</section>
		);
	} else {
		return '';
	}
};

export default BlogCommentList;
